import { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
  * {
    font-family: 'Helvetica LT Std';
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
`